import { Button } from "@/components/Button";
import { Card } from "@/components/Card";
import Checkbox from "@/components/Checkbox";

import Shimmer from "@/components/Shimmer";
import { H5 } from "@/components/Typography";
import {
  useGetActiveLanguages,
  useGetLanguages,
  usePutLanguages,
} from "@/requests/hooks/comply";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const Language = () => {
  const { t } = useTranslation();
  const [selectedLanguages, setSelectedLanguages] = useState<
    number[] | undefined
  >();
  const {
    data: languagesData,
    isFetching: isFetchingGetLanguages,
    isRefetching: isRefetchingGetLanguages,
  } = useGetLanguages();
  const {
    mutateAsync: putLanguages,
    isPending: isPendingPutLanguages,
    isSuccess: isSuccessPutLanguages,
  } = usePutLanguages();
  const {
    data: activeLanguages,
    isLoading: isLoadingGetActiveLanguages,
    refetch: refetchGetActiveLanguages,
  } = useGetActiveLanguages();

  useEffect(() => {
    if (!!activeLanguages && !selectedLanguages) {
      setSelectedLanguages(activeLanguages!);
    }
  }, [activeLanguages]);

  useEffect(() => {
    if (isSuccessPutLanguages)
      toast.success(t("comply.privacyCenter.language.toastSuccess"));
  }, [isSuccessPutLanguages]);

  const submit = async () => {
    await putLanguages(selectedLanguages);
    refetchGetActiveLanguages();
  };

  const onChangeSelectedLanguages = (id: number) => () => {
    if (selectedLanguages?.includes(id)) {
      let updatedLanguages = selectedLanguages;
      updatedLanguages = updatedLanguages.filter(
        languageId => languageId !== id,
      );

      setSelectedLanguages(updatedLanguages);
    } else {
      const updatedLanguages = selectedLanguages?.concat([id]);
      setSelectedLanguages(updatedLanguages);
    }
  };

  const renderCheckbox = ({ name, id }: ILanguage) => (
    <Checkbox
      key={id}
      name={name}
      label={name}
      checked={!!selectedLanguages?.includes(id)}
      onChange={onChangeSelectedLanguages(id)}
    />
  );

  const renderLoading = () => (
    <div className="px-25 py-20">
      <Shimmer width="100%" height={300} />
    </div>
  );

  const renderCard = () => (
    <Card>
      <div className="px-25 py-20">
        <H5 className="pb-10 font-bold">
          {t("comply.privacyCenter.language.title")}
        </H5>
        <div className="pb-20">
          <Trans i18nKey="comply.privacyCenter.language.description">
            zero
            <b>one</b>
          </Trans>
        </div>
        <div className="grid grid-cols-2 gap-20 md:grid-cols-7">
          {languagesData?.map(renderCheckbox)}
        </div>
      </div>
    </Card>
  );

  const renderButton = () => (
    <div className="mt-20 flex flex-grow justify-center md:pt-40">
      <Button
        as="button"
        variant="primary"
        onClick={submit}
        loading={isPendingPutLanguages}>
        {t("comply.privacyCenter.language.cta")}
      </Button>
    </div>
  );

  if (
    (isLoadingGetActiveLanguages || isFetchingGetLanguages) &&
    !isRefetchingGetLanguages
  )
    return renderLoading();

  return (
    <>
      {renderCard()}
      {renderButton()}
    </>
  );
};

export default Language;
